import {
  HHButton,
  HHStack,
  HHTypography,
  useHingeHealthSecurityContext,
} from '@hinge-health/react-component-library';
import { Link } from 'react-router-dom';
import { SplitWrapper } from '../../../components/split-wrapper';

export const HingeSelectHomePlaceholder = (): JSX.Element => {
  const { hingeHealthAuthState } = useHingeHealthSecurityContext();
  return (
    <HHStack spacing={3} sx={{ p: 4 }}>
      <HHTypography hhVariant="h1">Hinge Select</HHTypography>
      <HHTypography hhVariant="body">
        Internal admin tools for the HingeSelect.
      </HHTypography>
      <HHStack direction="row" spacing={2}>
        <SplitWrapper
          treatmentName="HINGE_SELECT_PROVIDER_CONTRACT"
          attributes={{
            uid: hingeHealthAuthState?.accessToken?.claims.uid.toString() || '',
          }}
        >
          <HHButton
            LinkComponent={Link}
            to="contracts/new/intake"
            hhVariant="variant-bypass"
            variant="contained"
            color="primary"
          >
            New contract onboarding
          </HHButton>
        </SplitWrapper>
      </HHStack>
    </HHStack>
  );
};
